import React, { useEffect, useRef } from 'react'; //, { useState,  }, useRef
import styled from 'styled-components';
import styles from "./statements.module.scss";
export const TableWrapper = styled.table`
    margin-top:${props => props.$marginTop ? "1rem" : ''};
    border-collapse: collapse; /* Ensures borders don’t double up */
    overflow: visible;
    td{
        padding: 8px;
        position: relative; /* Needed for box-shadow to work */
        overflow: visible;
    }
    td::after{
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none; /* Prevents interaction issues */
    }
    ${props => props.$finalTable ? `
        width:30rem;
        margin: 0 10% 0 auto;
        td:first-child{
            background-color:var(--extra-light-gray);
            color:var(--light-gray);
            text-align:right;
        }
        td:last-child{
            text-align:right;
        }
        tr:last-child{
            color:red;
        }
    ` : 
    `
        width: ${props.$cusomWidth || "100%"};
    `}
    td:not(:last-child){
        ::after{
            box-shadow: inset 0 -0.5px 0 var(--light-gray), /* Bottom border */
                        inset -0.5px 0 0 var(--light-gray); /* Left border */
        }
    }
    td:last-child{
        ::after{ -0.5px 0 var(--light-gray); 
            box-shadow: inset 0 -0.5px 0 var(--light-gray); /* Bottom border */
        }
    }
    
    &>thead{
        &>tr{
            background-color:var(--extra-light-gray);
            color:var(--light-gray);
            
        }
    }
    
    &>tbody>tr>td{
        font-weight:600;
        white-space: wrap;
        ${props => props.$summary ? 
        `
            padding: 0.8rem 8px;
            font-size:1.2rem;
            color:var(--extra-dark-gray);
        
        `:
        `
            color:var(--dark-gray);
        `}
        &>a{
            color:inherit;
        }
        &>.button{
            position:absolute;
            background:none;
            border-radius:0.3rem;
            cursor:pointer;
            font-weight:700;
            margin-top:-0.2rem;
        }
        &>.dismiss{
            &:disabled{
                display:none;
            }
            &:not(:disabled){
                margin-top:0;
                margin-left:1.2rem;
                border:none;
                width:1rem;
                height:1rem;
                ::after{
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-repeat: no-repeat no-repeat;
                    background-position: center center;
                    background-size: cover;
                    background-image: url('data:image/svg+xml,<svg stroke="currentColor" fill="rgb(253, 59, 59)" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" data-closable="true"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path></svg>'); 
                }
            }
            
        }
        &>.accept{
            margin-left:1.5rem;
            color:var(--main-color);
            border:var(--main-color) thin solid;
        }
        &>.decline{
            margin-left:7rem;
            color:var(--alert-color);
            border:var(--alert-color) thin solid;
        }
        &>.daysStepper{
            position:absolute;
            left:100%;
            right:auto;
            margin-left:2rem;
            top:50%;
            transform: translateY(-50%);
            display:flex;
            align-items:center;
            gap:0.2rem;
            z-index:2;
            button{
                position:static;
                margin:0;
                width:1.15rem;
                height:1.15rem;
                padding:0;
                border:thin solid var(--light-gray);
                border-radius:0.25rem;
                background:var(--bg);
                color:var(--dark-gray);
                font-weight:700;
                font-size:0.85rem;
                line-height:1;
                cursor:pointer;
                &:disabled{
                    opacity:0.35;
                    cursor:default;
                }
            }
            span{
                min-width:1.1rem;
                text-align:center;
                font-size:0.85rem;
                color:var(--dark-gray);
            }
        }
        &.hasAmountActions{
            overflow:visible;
            &>input{
                text-align:right;
            }
            &>.dismiss:not(:disabled){
                left:100%;
                right:auto;
                margin-left:0.5rem;
                margin-top:0;
                top:50%;
                transform: translateY(-50%);
                z-index:2;
            }
        }
        &>span.unfinished{
            font-size:0.8rem;
            color:var(--alert-color);
        }
        &>span.clickableloadnumber{
            text-decoration: underline;
            text-underline-offset: 0.2rem;
            :hover{
                color:var(--main-color);
            }
        }
        svg{
            color:var(--main-color);
            margin-bottom:-0.1rem;
            cursor:pointer;
        }
        &>select{
            background: var(--bg);
            font-family:var(--main-font-family);
            width:100%;
            font-weight:600;
            padding:0.2rem;
            color:var(--dark-gray);
            border:none;
            box-shadow: var(--button-outline);
            -moz-box-shadow: var(--button-outline);
            -webkit-box-shadow: var(--button-outline);
            transition:0.08s;
            border-radius:0.4rem;
            &:focus  {
                outline: rgba(48, 192, 140, 0.5) solid 0.25rem !important;
            }
        }
        option{
            background: var(--bg);
        }
        &>input, &>div>input{
            width:100%;
            border:none;
            font-weight:600;
            color:var(--dark-gray);
            font-family: var(--main-font-family);
            &:focus  {
                outline: rgba(48, 192, 140, 0.5) solid 0.25rem !important;
            }
            &:not(:disabled){
                background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5' height='5' viewBox='0 0 5 5'%3E%3Cpolygon points='0,5 5,5 5,0' fill='rgba(48, 192, 140, 0.5)'/%3E%3C/svg%3E") no-repeat bottom right;
            }
        }
        
    }
`
export const TableTemplate = ({tableConf,  currentDataset, isEditable, onReorder}) => {
    const colgroup = useRef(null);
    const thead = useRef(null);
    const tbody = useRef(null);
    useEffect(() => {
        if (colgroup.current &&  thead.current && tbody.current) {
            tbody.current.innerHTML = "";
            if(colgroup.current.childElementCount !== tableConf.columns.length){
                colgroup.current.innerHTML = "";
                thead.current.innerHTML = "";
            }
            currentDataset.forEach((job, index) =>{
                let jobRow = document.createElement("tr");
                tableConf.columns.forEach(columnData => {
                    let newElement = document.createElement("col");
                    if(colgroup.current.childElementCount < tableConf.columns.length){
                        newElement.style.width = columnData.width;
                        colgroup.current.appendChild(newElement);
                    }
                    if(tableConf.headerPresent && thead.current.childElementCount < tableConf.columns.length){
                        newElement = document.createElement("td");
                        newElement.innerText = columnData.label;
                        newElement.style.textAlign = columnData.alignment || '';
                        thead.current.appendChild(newElement);
                    }
                    newElement = document.createElement("td");
                    if(columnData.addButton){
                        newElement.className = `${styles.addButton} non-selectable`;
                        const addButton = document.createElement("div");
                        addButton.onclick = columnData.addButton;
                        newElement.appendChild(addButton);
                        jobRow.appendChild(newElement);
                        return;
                    }
                    if(columnData.dragger){
                        newElement.className = `${styles.dragger} non-selectable`;
                        jobRow.appendChild(newElement);
                        return;
                    }
                    if(job.customJob){
                        columnData.editable = true;
                    }
                    
                    const defaultValue = columnData.customFormat ? columnData.customFormat(columnData.calculation ? columnData.calculation(job) : job[columnData.name], columnData.dataRequiredForCustomFormatting ? job : null) : columnData.calculation ? columnData.calculation(job) : job[columnData.name] === 0 ?"-":job[columnData.name];                    
                    if(columnData.type === "select"){
                        newElement.appendChild(adjustmentTypeSelector(defaultValue, columnData.cellEdit, index, isEditable))                        
                    }else if((columnData.editable && (!columnData.cellEdit || !columnData.cellEdit(newElement, job, index))) || job.customAdjustment){
                        const input = document.createElement("input");
                        input.type = "text";
                        input.defaultValue = defaultValue;
                        if(columnData.label === "Description"){
                            input.placeholder = "Description Here"
                        }
                        input.dataset.index = index;
                        input.dataset.name = columnData.name;
                        input.style.textAlign = columnData.alignment || '';
                        if(columnData.editInputStyle){
                            columnData.editInputStyle(input, job);
                        }
                        input.oninput = (e)=>{
                            if(columnData.onEdit)e.target.value = columnData.onEdit(e.target.value, job);
                        }
                        input.onblur = (e)=>{
                            if(columnData.onBlur)columnData.onBlur(e.target, job, index);
                        }
                        input.onpaste = (e)=>{
                            if(columnData.onPaste)e.target.value = columnData.onPaste(e.target.value, job);
                        }
                        if(newElement.childElementCount > 0){
                            newElement.insertBefore(input, newElement.childNodes[0]);
                        }else{
                            newElement.appendChild(input);
                        }
                        
                    }else{
                        // if(currentDataset.customJob){
                            
                        // }
                        newElement.style.textAlign = columnData.alignment || '';
                        newElement.innerHTML = defaultValue;
                        if(columnData.cellEdit ){
                            columnData.cellEdit(newElement, job, index);
                        }
                    }
                    jobRow.appendChild(newElement);
                });
                tbody.current.appendChild(jobRow);
            })
            if(!isEditable && tbody.current){
                const interactiveElements = tbody.current.querySelectorAll('input, select, button');
                Array.from(interactiveElements, el => el.disabled = true);
            }
            if (tableConf.reorderingAllowed && typeof onReorder === 'function' && Array.isArray(currentDataset) && tbody.current) {
                const rows = tbody.current.children;
                Array.from(rows).forEach((tr, index) => {
                    tr.draggable = false;
                    tr.onmousedown = (e) => {
                        if (e.target.closest(`.${styles.dragger}`)) {
                            tr.dataset.dragFromHandle = "1";
                            tr.draggable = true;
                        } else {
                            tr.dataset.dragFromHandle = "";
                        }
                    };
                    tr.onmouseup = tr.onmouseleave = () => {
                        delete tr.dataset.dragFromHandle;
                        tr.draggable = false;
                    };
                    tr.ondragstart = (e) => {
                        if (!tr.dataset.dragFromHandle) {
                            e.preventDefault();
                            return;
                        }
                        e.dataTransfer.setData("text/plain", String(index));
                        e.dataTransfer.effectAllowed = "move";
                        tr.classList.add(styles.dragging);
                    };
                    tr.ondragend = () => {
                        delete tr.dataset.dragFromHandle;
                        tr.draggable = false;
                        tr.classList.remove(styles.dragging);
                        Array.from(rows).forEach(r => r.classList.remove(styles.dragOver));
                    };
                    tr.ondragover = (e) => {
                        e.preventDefault();
                        e.dataTransfer.dropEffect = "move";
                        tr.classList.add(styles.dragOver);
                    };
                    tr.ondragleave = () => {
                        tr.classList.remove(styles.dragOver);
                    };
                    tr.ondrop = (e) => {
                        e.preventDefault();
                        tr.classList.remove(styles.dragOver);
                        const fromIdx = parseInt(e.dataTransfer.getData("text/plain"), 10);
                        const toIdx = Array.from(rows).indexOf(e.currentTarget);
                        if (fromIdx === toIdx || Number.isNaN(fromIdx)) return;
                        const reordered = [...currentDataset];
                        const [removed] = reordered.splice(fromIdx, 1);
                        reordered.splice(toIdx, 0, removed);
                        onReorder(reordered);
                    };
                });
            }
        }
        // eslint-disable-next-line
    }, [colgroup.current, currentDataset, tableConf, onReorder])
    
    
    return <TableWrapper $marginTop={tableConf.headerPresent} $summary={tableConf.tableSummary} $cusomWidth={tableConf.customWidth || null} >
        <colgroup ref={colgroup}>
        </colgroup>
        <thead>
            <tr ref={thead}>
            </tr>
        </thead>
        <tbody ref={tbody}>    
        </tbody>
    </TableWrapper>;
}


export function isRecurringBonus(item) {
    if (!item) return false;
    return item.type === "bonus" || item.cat === "bns";
}

export function isPerMileAdjustment(item) {
    return item?.perMile === true;
}

/** Dollar amount for a per-mile row. weeklyRate stays the per-mile rate. */
export function perMileDollarAmount(item) {
    const miles = Math.max(0, Math.trunc(Number(item?.miles) || 0));
    const rate = Math.abs(Number(item?.weeklyRate) || 0);
    return Math.round(miles * rate * 100) / 100;
}

export function formatPerMileRateLabel(rate) {
    const amount = Math.abs(Number(rate) || 0);
    const shown = amount.toFixed(8).replace(/\.?0+$/, '');
    return `$${shown || '0'}/mi`;
}

export function perMileRowLabel(item) {
    const title = item?.title || '';
    return `${title} (${formatPerMileRateLabel(item?.weeklyRate)})`;
}

export function signedWeeklyRate(item) {
    const rate = isPerMileAdjustment(item)
        ? perMileDollarAmount(item)
        : (Number(item?.weeklyRate) || 0);
    return isRecurringBonus(item) ? rate : -rate;
}

function adjustmentTypeSelector(val, onEdit, index, isEditable){
    const selectTag = document.createElement("select");
    selectTag.disabled = !isEditable;
    selectTag.oninput = (e)=>{
        onEdit(e.target.value, index, val)
        // if(columnData.onEdit)e.target.value = columnData.onEdit(e.target.value, job);
    }
    const charge = document.createElement("option");
    charge.innerText = "Charge";
    charge.value = "chrg"
    selectTag.appendChild(charge);
    if("weeklyRate" in val){
        if(isRecurringBonus(val)){
            const bonus = document.createElement("option");
            bonus.innerText = "Bonus";
            bonus.value = "bns";
            selectTag.appendChild(bonus);
            selectTag.value = "bns";
        }else{
            selectTag.value = "chrg";
        }
        selectTag.disabled = true;
        return selectTag;
    }
    if(val.type === "charge" || val.amount < 0){
        selectTag.value = "chrg";
        selectTag.disabled = true;
        return selectTag
    }
    let optionTag = document.createElement("option");
    optionTag.innerText = "Bonus";
    optionTag.value = "bns"
    selectTag.appendChild(optionTag);
    if(val.type === "bonus"){
        selectTag.value = "bns";
        selectTag.disabled = true;
        return selectTag;
    }
    optionTag = document.createElement("option");
    optionTag.innerText = "Reimb.";
    optionTag.value = "rmb";
    selectTag.appendChild(optionTag);
    if(val.type === "reimbursement"){
        selectTag.value = "rmb";
        selectTag.disabled = true;
        return selectTag;
    }
    selectTag.value = val.cat || (val.amount === 0 ? "" : "bns");
    return selectTag;
}
export function obtainBonusReimDeducValues(statement){
    const result = {
        "totalDeductions": 0,
        "totalBonuses" : 0,
        "totalReimbursements" : 0
    };
    if(statement.adjustmentsArray){
        for(const adjustment of statement.adjustmentsArray){
            if("weeklyRate" in adjustment){
                const amount = isPerMileAdjustment(adjustment)
                    ? perMileDollarAmount(adjustment)
                    : (Number(adjustment.weeklyRate) || 0);
                if(isRecurringBonus(adjustment)){
                    result.totalBonuses += amount;
                }else{
                    result.totalDeductions += amount;
                }
            }else if(adjustment.amount < 0){
                result.totalDeductions -= adjustment.amount;
            }else if(adjustment.type === "charge"){
                result.totalDeductions += adjustment.amount;
            }else if(adjustment.type === "bonus"){
                result.totalBonuses += adjustment.amount;
            }else if(adjustment.type === "reimbursement"){
                result.totalReimbursements += adjustment.amount;
            }else{
                if(adjustment.cat){
                    switch (adjustment.cat) {
                        case "chrg":
                            result.totalDeductions += adjustment.amount;
                            break;
                        case "rmb":
                            result.totalReimbursements += adjustment.amount;
                            break;
                        case "bns":
                            result.totalBonuses += adjustment.amount;
                            break;
                        default:
                            break;
                    }
                }else{
                    if(adjustment.amount > 0){
                        result.totalBonuses += adjustment.amount;
                    }else{
                        result.totalDeductions -= adjustment.amount;
                    }
                }
                
            }
        }
    }
    const statementCopy = {...statement};
    for(const key of Object.keys(result)){
        statementCopy[key] = result[key];
    }
    return statementCopy;
}